module.exports = __webpack_public_path__ + "static/media/munikum-logo-white.fb245ba6.svg";